import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17.7 19.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.85 0A4.36 4.36 0 0 0 4.5 4.35 4.36 4.36 0 0 0 8.85 8.7c2.393 0 4.35-1.957 4.35-4.35S11.242 0 8.85 0zm0 1.5c1.583 0 2.85 1.267 2.85 2.85S10.432 7.2 8.85 7.2A2.838 2.838 0 0 1 6 4.35 2.838 2.838 0 0 1 8.85 1.5zM8.85 9.9C3.97 9.9 0 13.871 0 18.75a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75c0-4.068 3.281-7.35 7.35-7.35s7.35 3.282 7.35 7.35a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75c0-4.879-3.972-8.85-8.85-8.85z" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "customer"}) } }